export const featureName = 'cashier';